import React from 'react';
import { ModalHeader } from '@televet/kibble-ui/build/components/Modal/components/ModalHeader';
import { AppointmentModalHeader } from './components/AppointmentModalHeader';
import { Box } from '@televet/kibble-ui/build/chakra';
import { AppointmentModalBody } from './components/AppointmentModalBody';
import { ModalCloseButton } from '@televet/kibble-ui/build/components/Modal/components/ModalCloseButton';

export function NewAppointmentModal(): JSX.Element {
  return (
    <>
      <ModalHeader size="md">Appointment Details</ModalHeader>
      <ModalCloseButton />
      <Box px={6} pt={3} pb={6}>
        <AppointmentModalHeader />
        <AppointmentModalBody />
      </Box>
    </>
  );
}
